import {get} from "lodash"
import {headers} from "../constants/headers"

export default function getTraceIdFromError(err: any): string {
  return getNormalResponse(err, headers.correlationId) || getNormalResponse(err, headers.xAmzRequestId) || null
}

function getNormalResponse(err: any, header: string) {
  return get(err, `response.headers[${header}]`)
}
